import type { FaireProductEntity } from "../../entity_types/product";

export const p_1a4lqikhph: FaireProductEntity = {
  token: "p_1a4lqikhph",
  type: "product",
  name: "Sweet New Home Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/973477f9b84b4abf39c3fb2b0febb4965853f5db59b560b1748ca5a93b678b1b/1558021017.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/40970aa2909298949932b91d18b70e1d5c2f086b29c73e2fea5c26dbd173f3d0/1558021023.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:01.594Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
